const ArrowRightIcon = ({
  width = 48,
  height = 48,
  fill = "black",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      opacity="0.03"
      width="48"
      height="48"
      transform="matrix(-1 0 0 1 48 0)"
      fill={fill}
    />
    <path
      d="M32.7998 23.726L18.8112 15.6497L18.8112 31.8023L32.7998 23.726Z"
      fill={fill}
    />
  </svg>
);

export default ArrowRightIcon;
